import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PresenterType } from '@app/shared';
import { ExportQueuedModel } from './export-queued.model';

@PresenterType({
  model: ExportQueuedModel,
})

@Component({
  selector: 'export-queued-message',
  standalone: false,
  templateUrl: './export-queued-message.component.html',
  styleUrl: './export-queued-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportQueuedMessageComponent {

}
